// removed by extract-text-webpack-plugin
module.exports = {"medallion":"_1ZUJF5b2Zr6B65XYYRRX1p","active":"_2oScJHKXCfHRZoMrA9eyu0","ripple":"CY30nT3C_BNBmT9BD241d","emoji":"_25EXDwmZgEsdsNKdvNcFuw"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/medallion/medallion.scss
// module id = 424
// module chunks = 0